import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthService } from '@/services/auth';
import { CircularProgress } from '@mui/material';
import { AuthBoxContainer } from './AuthBox';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuthService();

  if (isLoading) {
    return (
      <AuthBoxContainer>
        <CircularProgress size={24} color='inherit' />
      </AuthBoxContainer>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to='/signin' state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
